import ShBreadcrumb from '@/components/Helpers/ShBreadcrumb';
import ShDividerLine from '@/components/Helpers/ShDividerLine';

// @vue/component
export default {
  name: 'PageHeader',

  components: { ShBreadcrumb, ShDividerLine },

  props: {
    faIcon: {
      type: String,
      default: 'circle-thin',
    },
    title: {
      type: String,
      default: 'Page header title',
    },
    description: {
      type: String,
      default: 'Page header description',
    },
    breadcrumbItems: {
      type: Array,
      default: () => [],
    },
    hasHint: {
      type: Boolean,
      default: false,
    },
    isBackButtonVisible: {
      type: Boolean,
      default: true,
    }
  },
};
